/**
 * Self-contained inline SVG placeholder for product thumbnails.
 * Used everywhere instead of via.placeholder.com (which is unreliable).
 * No external request — renders instantly even offline.
 */
const SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
  <rect width="200" height="200" fill="#F1F5F9"/>
  <g fill="#94A3B8" transform="translate(60 56)">
    <path d="M40 0a16 16 0 0 1 16 16v8h12a8 8 0 0 1 8 8v40a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V32a8 8 0 0 1 8-8h12v-8A16 16 0 0 1 40 0Zm0 8a8 8 0 0 0-8 8v8h16v-8a8 8 0 0 0-8-8Z"/>
  </g>
  <text x="100" y="160" text-anchor="middle" fill="#94A3B8" font-family="Arial,sans-serif" font-size="14" font-weight="600">No Image</text>
</svg>`;

export const PLACEHOLDER_IMG = `data:image/svg+xml;utf8,${encodeURIComponent(SVG)}`;

export function handleImgError(e) {
  // Prevent infinite onError loop by clearing the handler before swap
  if (e?.target) {
    e.target.onerror = null;
    e.target.src = PLACEHOLDER_IMG;
  }
}
